<template>
  <div class="dashboard-view">
    <why-timer ref="timer" />
  </div>
</template>

<script>
import whyTimer from '@/components/whyTimer'
export default {
  name: 'dashboard',
  data () {
    return { }
  },
  components: { whyTimer },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '工作台' }])
  },
  mounted () {
    this.$refs.timer.start()
  }
}
</script>

<style lang="scss">
.dashboard-view {
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue